export const isProduction = (): boolean => (window && window.location.host === 'assine.estadao.com.br')